var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "setting-content" },
    _vm._l(_vm.menu, function (list, index) {
      return _c("div", { key: index, staticClass: "page-card-item" }, [
        _c(
          "div",
          {
            staticStyle: { height: "100%" },
            on: {
              click: function ($event) {
                return _vm.$router.push({ path: "/" + list.href })
              },
            },
          },
          [
            _c("label", { staticClass: "top" }),
            _c(
              "label",
              {
                class: [
                  "bottom",
                  _vm.$i18n.locale === "en" ? "en-fontSize" : "",
                ],
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t(list.menuCode)))])]
            ),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }